export default __webpack_public_path__ + "static/media/Buildings_Dinning_Hall.ab056158.JPG";